let baseURL;

// if (process.env.REACT_APP_BACKEND_URL) {
//   console.log('采用自定义后端API模式', process.env.REACT_APP_BACKEND_URL);
//   baseURL = process.env.REACT_APP_BACKEND_URL;
// } else {
//   if (process.env.REACT_APP_BACKEND_TYPE === 'dev') {
//     baseURL = '//127.0.0.1:10888'; // todo
//   } else if (process.env.REACT_APP_BACKEND_TYPE === 'public') {
//     baseURL = '//real.tuzhi.ai:34443';  // 公开版本也使用真实服务器
//   } else if (process.env.REACT_APP_BACKEND_TYPE === 'local' || !process.env.REACT_APP_BACKEND_TYPE) {
//     process.env.REACT_APP_BACKEND_TYPE = 'local';
//     baseURL = '//127.0.0.1:10888';
//   }
// }

// 修改为根据当前前端页面地址，动态映射后端API地址
const hostMap: {
  [host: string]: {
    api: string,
    name: string,
    apiV2?: string,
  }

} = {
  'localhost:4091': {
    api: '//127.0.0.1:10888', name: '图智本地开发平台',
    apiV2: '//127.0.0.1:10889',
  },
  '127.0.0.1:4091': {
    api: '//127.0.0.1:10888', name: '图智本地开发平台',
    apiV2: '//127.0.0.1:10889',
  },
  'next.tuzhi.ai': {
    api: '//next-api.tuzhi.ai', name: '图智清华测试平台',
  },
  'dev.tuzhi.ai': {
    api: '//dev-api.tuzhi.ai', name: '图智清大东方测试平台',
  },
  'ss.tuzhi.ai:7443': {
    api: '//ss.tuzhi.ai:7443/api', name: '图智施工图孵化环境',
    // TODO: ss 施工图等环境先保留原来的配置，后面真删老接口了再一次性同步更新吧
    apiV2: '//ss.tuzhi.ai:7443/api',
  },
};

// export const API_BASE_URL = baseURL;
// export const API_BASE_URL = hostMap[window.location.host]?.api || '/api';  // 默认使用nginx转发的/api路径
export const API_BASE_URL = hostMap[window.location.host]?.api || (process.env.PUBLIC_URL || '') + '/api';  // 默认使用nginx转发的/api路径
export const API_V2_BASE_URL = hostMap[window.location.host]?.apiV2 || (process.env.PUBLIC_URL || '') + '/api/v2';  // 默认使用nginx转发的/api路径
export const API_NAME = hostMap[window.location.host]?.name || '图智未授权环境';

/**
 * API 前缀路由映射表
 *
 * 每个 key 是一个 API 路径前缀（不含尾部 /），value 是目标 baseURL
 *
 * TODO: 渐进迁移计划如下，后面慢慢全部迁移，避免 feature 下接口重复，
 *  另外后端也需要重新统一接口，再新增多种认证方式方便对接。
 *  /asset -> V2 (已完成)
 *  /check -> V2 (已完成)
 *  /log -> V2（日志流，token 换发与 SSE 端点）
 *  其他全部默认 -> v1 待重构迁移
 */
export const API_ROUTE_MAP: Record<string, string> = {
  '/asset': API_V2_BASE_URL,
  '/check': API_V2_BASE_URL,
  '/log': API_V2_BASE_URL,
};

// 动态主题配置
let TUZHI_THEME: string;
// 如果有debug_theme参数，则强制切换主题
const urlParams = new URLSearchParams(window.location.search);
const debugTheme = urlParams.get('debug_theme');
if (debugTheme) {
  TUZHI_THEME = debugTheme;
  alert(`开启主题注入${debugTheme}`);
} else {
  TUZHI_THEME = process.env.REACT_APP_THEME || 'default';
}


export function getTuzhiTheme(): string {
  return TUZHI_THEME;
}

export function setTuzhiTheme(theme: string) {
  TUZHI_THEME = theme;
}
